/* eslint-disable eslint-comments/no-unlimited-disable */
/* eslint-disable */
import * as React from "react";

import { Header } from "semantic-ui-react";
import { connect } from "react-redux";

import { mapStateToQuestionnaireSectionProps, mapDispatchToQuestionnaireSectionProps } from "../mappers";
import { QuestionnaireSectionProps } from "../QuestionnaireSectionProps";
import { registerQuestionnaireSection, renderQuestions, registerQuestionsForSection, isSectionVisible } from "../utils";

import "../styles/progress-bar-questionnaire-section.scss";

/**
 * @deprecated Prefer ContextAwareProgressBarQuestionnaireSectionUnconnected unless you're being used within an OldProgressBarQuestionnaireContainer
 */
export class OldProgressBarQuestionnaireSectionUnconnected extends React.Component<QuestionnaireSectionProps> {
    constructor(props: QuestionnaireSectionProps) {
        super(props);
    }

    public componentDidMount() {
        registerQuestionnaireSection(this.props);
        registerQuestionsForSection(this.props);
    }

    public componentWillUnmount() {
        this.props.removeSection({ questionnaireKey: this.props.questionnaireKey, sectionId: this.props.id });
    }

    public componentDidUpdate(prevProps: QuestionnaireSectionProps) {
        if (this.props.children !== prevProps.children) {
            registerQuestionsForSection(this.props);
        }
    }

    public render() {
        if (!this.props.readonly && !this.props.active) {
            return null;
        }

        if (isSectionVisible(this.props) !== true) {
            return null;
        }

        return (
            <>
                <Header className="section-header" as="h2" inverted block>{this.props.title}</Header>
                {renderQuestions(this.props)}
            </>
        );
    }
}

/**
 * @deprecated Prefer ContextAwareProgressBarQuestionnaireSection unless you're being used within an OldProgressBarQuestionnaireContainer
 */
export const OldProgressBarQuestionnaireSection = connect(mapStateToQuestionnaireSectionProps, mapDispatchToQuestionnaireSectionProps)(OldProgressBarQuestionnaireSectionUnconnected);
